import { render, staticRenderFns } from "./lawFirm.vue?vue&type=template&id=63ec3a60&scoped=true"
import script from "./lawFirm.vue?vue&type=script&lang=js"
export * from "./lawFirm.vue?vue&type=script&lang=js"
import style0 from "./lawFirm.vue?vue&type=style&index=0&id=63ec3a60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec3a60",
  null
  
)

export default component.exports